import SettingsLayout from "../Layout";

import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

// Tabs
import GeneralTab from "./Tabs/General";

  const tabContent = [
    {panel: "general", content: <GeneralTab />},
  ]

const CCSettings = () => {

  const tabs = [
    {label: "General", icon: <ReceiptLongRoundedIcon fontSize="small" />},
  ];

  return (
    <SettingsLayout title="Credit Card" identifier="invoice_id" tabs={tabs} tabContent={tabContent} url="settings/cc">

    </SettingsLayout>
  )
};

export default CCSettings;